import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './common/auth.guard';
import { AuthReverseGuard } from './common/authReverse.guard';
import { SelectivePreloadStrategy } from './core/strategies/selective-preload.strategy';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginModule),
    canActivate: [AuthReverseGuard],
    data: { breadcrumb: { skip: true } },
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        title: 'INICIO',
        parent: '',
        path: 'home',
      },
    },
  },
  {
    path: 'session-expired',
    loadComponent: () =>
      import('./pages/session-expired/session-expired.component').then((m) => m.SessionExpiredComponent),
    canActivate: [AuthReverseGuard],
    data: { breadcrumb: { skip: true } },
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./pages/register/register.module').then((m) => m.RegisterModule),
    canActivate: [AuthReverseGuard],
    data: { breadcrumb: { skip: true } },
  },
  {
    path: 'info',
    loadChildren: () =>
      import('./pages/info-pages/info-pages.module').then(
        (m) => m.InfoPagesModule
      ),
    data: { breadcrumb: { skip: true } },
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./pages/profile/profile.module').then((m) => m.ProfileModule),
    data: { breadcrumb: { skip: true } },
  },
  {
    path: 'users',
    loadChildren: () =>
      import('./pages/users/users.module').then((m) => m.UsersModule),
    data: { breadcrumb: { skip: true } },
  },
  {
    path: 'notifications',
    loadChildren: () =>
      import(
        './pages/internal-notifications/internal-notifications.module'
      ).then((m) => m.InternalNotificationsModule),
    data: { breadcrumb: { skip: true } },
  },
  {
    path: 'digital-signature',
    loadChildren: () =>
      import('./pages/digital-signature/digital-signature.module').then(
        (m) => m.DigitalSignatureModule
      ),
    data: { breadcrumb: { skip: true } },
  },
  {
    path: 'mailshot',
    loadChildren: () =>
      import('./pages/mailshot/mailshot.module').then((m) => m.MailshotModule),
    data: { breadcrumb: { skip: true } },
  },
  {
    path: 'quote',
    loadChildren: () =>
      import('./pages/quote/quote.module').then(
        (m) => m.QuoteModule
      ),
    data: { breadcrumb: { skip: true } },
  },
  {
    path: 'dealers',
    loadChildren: () =>
      import('./pages/dealers/dealer.module').then(
        (m) => m.DealersModule
      ),
    data: { breadcrumb: { skip: true } },
  },
  {
    path: 'marketing',
    loadChildren: () =>
      import('./pages/marketing/marketing.module').then((m) => m.MarketingModule),
    data: { breadcrumb: { skip: true } },
  },
  {
    path: 'credito',
    loadChildren: () =>
      import('./pages/credito/credito.module').then((m) => m.CreditoModule),
    data: { breadcrumb: { skip: true } },
  },
  {
    path: 'floor-plan',
    loadChildren: () =>
      import('./pages/floor-plan/floor-plan.module').then((m) => m.FloorPlanModule),
    data: { breadcrumb: { skip: true } },
  },
  {
    path: 'clients',
    loadChildren: () =>
      import('./pages/clients/clients.module').then(
        (m) => m.ClientsModule
      ),
    data: { breadcrumb: { skip: true } },
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./pages/onboarding/onboarding.module').then(
        (m) => m.OnboardingModule
      ),
    // `preload: true` warms up this heavy chunk in idle time after the app
    // boots, so opening onboarding from the menu no longer freezes while the
    // module downloads. See SelectivePreloadStrategy.
    data: { breadcrumb: { skip: true }, preload: true },
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: SelectivePreloadStrategy,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
